export const DEFAULT_PRODUCT_TYPE = "";

export function normalizeProductType(productType?: string | null): string {
  return productType ?? DEFAULT_PRODUCT_TYPE;
}

export function normalizeActionId(actionId?: string | null): string {
  return actionId ?? "";
}

/** Recoil ownership key: productType + actionId. Empty productType is valid for single-part V1. */
export function customImpositionStateKey(
  productType?: string | null,
  actionId?: string | null,
): string {
  return `${normalizeProductType(productType)}\u001f${normalizeActionId(actionId)}`;
}
